export default {"src":"/_next/static/media/0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2.995b0445.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};